import { useEffect } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import { useDispatch } from "react-redux";

import { markInitialFiltersReady } from "app/pages/sales-intelligence/modules/advanced-search-filtering/store/action-creators";
import type { FiltersConfigStatus } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filtersConfig";
import { filtersConfigStatusMap } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filtersConfig";
import type { SavedSearchRoutingParams } from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/types";

import { useIsTerritoryEligible } from "./useIsTerritoryEligible";

export const useMarkInitialFiltersReady = (status: FiltersConfigStatus): void => {
    const dispatch = useDispatch();

    const isTerritoryEligible = useIsTerritoryEligible();

    const {
        params: { savedSearchId },
    } = useCurrentStateAndParams<Partial<SavedSearchRoutingParams>>();

    useEffect(() => {
        if (!isTerritoryEligible && !savedSearchId && status === filtersConfigStatusMap.ready) {
            dispatch(markInitialFiltersReady());
        }
    }, [isTerritoryEligible, savedSearchId, status, dispatch]);
};
